// React Imports
import React, { useEffect, useState } from "react";

// Project Imports
import { Form } from "react-bootstrap";
import { observer } from "mobx-react";

// Package Imports
import { BottomsheetDropdown, CustomCheckbox, DatepickerModal } from "components";
import { CalenderIcon, DOBIcon, GenderIcon, IncomeIcon, MonthlyIncomeIcon, NationalityIcon, lifeCoverIcon } from "constants/Images";
import checkIsValueEmpty from "utils/checkIsValueEmpty";


import { NUMBER_REGEX } from 'constants/Constants'

// CSS Imports
import "../../components/add-family-member-card.css"
import { object } from "prop-types";
import moment from "moment";
import AuthStore from "modules/login/store/AuthStore";
import { toJS } from "mobx";
import { getEligibleProposerList } from "modules/family-details-form/non-individual-journey-form/utils";

import FamilyMemberTypeEnum from "modules/family-details-form/FamilymemberTypeEnum";
import FamilyDetailsStore from "modules/family-details-form/store/FamilyDetailsStore";
import { EMPLOYER_EMPLOYEE_SCHEME_A, EMPLOYER_EMPLOYEE_SCHEME_B, HUF, KEYMAN, MWP_ACT, PARTNERSHIP } from "constants/ CustomerType";
import { LA_PR_FAMILY_PROFILE } from "constants/UserClicksConstant";

const AddLifeAssuredData = ({ member, updateValues, onAddNameClick, memberCount, formController, setLastSelectedLa, setLastSelectedPR, isProtectionNeedSelected, lastSelectedLA, memberData }) => {

    let journeyData = toJS(AuthStore.journeyData)
    let familyData = Object.entries(formController.$("members").get())
    const listOfSelectedFamilyMembers = familyData.filter((item) => item[1].extra.isSelected)
    let otherMemberSelected = false

    useEffect(() => {
        let CustomerType = [EMPLOYER_EMPLOYEE_SCHEME_A, HUF, PARTNERSHIP, KEYMAN]

        if (journeyData && memberData && CustomerType.includes(AuthStore.journeyTypeName)) {

            memberData.forEach((data, index) => {
                if (memberData.length === index + 1) {
                    onChangeLifeAssured(true, data[0])
                }else{
                    onChangeLifeAssured(false, data[0])

                }

            })
        }else if(journeyData && memberData && (AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_B || AuthStore.journeyTypeName === MWP_ACT)){
            memberData.forEach((data, index) => {
                if (memberData.length === index + 1) {
                    onChangeLifeAssured(true, data[0])
                    onChangeProposer(true , data[0])
                }else{
                    onChangeLifeAssured(false, data[0])
                    onChangeProposer(false , data[0])
                }
            })
        }

    }, [memberCount])


    let memberfieldData = member[1].fields
    // console.log("nnnn>> ", member)
    let isFirstNameEntered = checkIsValueEmpty(memberfieldData.first_name.value)
    let isLastNameEntered = checkIsValueEmpty(memberfieldData.middle_name.value)
    let isMiddleNameEntered = checkIsValueEmpty(memberfieldData.last_name.value)
    let isNameEntered = false
    let name = ""

    if (!isFirstNameEntered || !isLastNameEntered || !isMiddleNameEntered) {
        isNameEntered = true
        name = memberCount + "." + " " + memberfieldData.salutation.value.label + " " + memberfieldData.first_name.value + " " + memberfieldData.middle_name.value + " " + memberfieldData.last_name.value
    }

    let memberAge = moment().diff(moment(memberfieldData.dob.value), 'years')
    // console.log('memberfieldData.dob.value ', member[0], memberAge)
    // if (isProtectionNeedSelected) {
    //     if (memberAge >= 85) {
    //         updateValues(formController, member[0], 'life_assured', false)
    //         age(true)
    //     } else if (memberfieldData.proposer.value === true) {
    //         updateValues(formController, member[0], 'life_assured', true)
    //         age(false)
    //     } 
    // } else {
    //     if (memberAge >= 85) {
    //         updateValues(formController, member[0], 'life_assured', false)
    //         age(true)
    //     }else{
    //         age(false)
    //     }

    // }


    const showmonthlyIncome = memberfieldData.monthly_income_value.extra.visible



    const onChangeLifeAssured = (value, selectedMember) => {
        updateValues(formController, selectedMember, 'life_assured', value)
        setLastSelectedLa(selectedMember)
    }

    const onChangeProposer = (value, selectedMember) => {
        updateValues(formController, selectedMember, 'proposer', value)
        setLastSelectedPR(selectedMember)
    }

    useEffect(() => {
        if (member[0] === lastSelectedLA) {
            getEligibleProposerList(member, formController, journeyData)
        }
    }, [lastSelectedLA])


    return (
        <div className='px-3 px-xl-2 border-bottom mt-3 pb-3'>
            <div className='d-flex justify-content-between'>
                <p className='mt-1 mb-0 mr-1 font-size-lg-14 font-size-14 font-weight-medium font-weight-lg-light '>
                    <span className="text-secondary"> {` ${memberCount}.`}</span> {member[1].label}
                </p>
                {/* nationality in mobile view */}
                <div className='d-flex align-items-center justify-content-between d-lg-none'>
                    <div className='d-flex d-xl-none align-items-center  mb-1'>
                        <p className='font-size-14 font-size-md-12 font-weight-normal text-description-text-color ml-1 mb-0 ml-md-3 pr-1'>
                            {memberfieldData.nationality.label}
                        </p>
                    </div>

                    <div className='d-flex'>
                        <BottomsheetDropdown
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={memberfieldData.nationality.extra.bottomSheetTitle}
                            defaultLabel={memberfieldData.nationality.label}
                            menuList={memberfieldData.nationality.extra.optionList}
                            value={memberfieldData.nationality.value}
                            onSelect={(value) => updateValues(formController, member[0], 'nationality', value)}
                            showErrorMsg={memberfieldData.nationality.error != null}
                            disabled={false}
                        />
                    </div>
                </div>
                <div className="d-none d-lg-block">
                    <CustomCheckbox
                        shape='rounded'
                        title={memberfieldData.life_assured.label}
                        containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                        titleStyle='fw-medium font-size-14 pl-1 pr-2  details-title-text'
                        isChecked={memberfieldData.life_assured.value}
                        onChange={(value) => {
                            onChangeLifeAssured(value, member[0]),
                            //! for save user clicks
                            AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                        }}
                        mark='checkmark'
                        disabled={memberfieldData.life_assured.disabled || memberAge >= 85 ? true : false}
                    />

                    <CustomCheckbox
                        shape='rounded'
                        title={memberfieldData.proposer.label}
                        containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                        titleStyle='fw-medium font-size-14 pl-1 pr-2 details-title-text '
                        isChecked={memberfieldData.proposer.value}
                        onChange={(value) => {
                            onChangeProposer(value, member[0]),
                            //! for save user clicks
                            AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                        }}
                        mark='checkmark'
                        disabled={memberfieldData.proposer.disabled}
                    />
                </div>
            </div>

            <hr className='w-100 border-secondary-opacity-50 my-2 d-lg-none' />

            <div className="d-block d-lg-none d-flex align-items-center justify-content-between mb-2">
                <CustomCheckbox
                    shape='rounded'
                    title={memberfieldData.life_assured.label}
                    containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                    titleStyle='fw-medium font-size-14 pl-1 pr-2  details-title-text'
                    isChecked={memberfieldData.life_assured.value}
                    onChange={(value) => {
                        onChangeLifeAssured(value, member[0]),
                        //! for save user clicks
                        AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                    }}
                    mark='checkmark'
                    disabled={memberfieldData.life_assured.disabled || memberAge >= 85 ? true : false}
                />

                <CustomCheckbox
                    shape='rounded'
                    title={memberfieldData.proposer.label}
                    containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                    titleStyle='fw-medium font-size-14 pl-1 pr-2 details-title-text '
                    isChecked={memberfieldData.proposer.value}
                    onChange={(value) => {
                        onChangeProposer(value, member[0]),
                        //! for save user clicks
                        AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                    }}
                    mark='checkmark'
                    disabled={memberfieldData.proposer.disabled}
                />
            </div>
            <div className='mt-1 d-flex flex-wrap'>
                <div className='family-member-name-section d-flex flex-lg-row justify-content-between'>
                    {/* <p
                        className='mt-1 mb-0 font-size-lg-12 font-size-14 font-weight-medium font-weight-lg-light text-secondary'
                    >
                        {
                            isNameEntered
                                ? name
                                : [member[1].label]
                        }
                        {
                            isNameEntered
                                ? null
                                : <span onClick={onAddNameClick}
                                    className="font-size-14 font-size-lg-12 font-weight-light text-description-text-color pl-1 cursor-pointer"
                                >
                                    {'TAP TO ADD NAME'}
                                </span>
                        }

                    </p> */}

                    <div className="mr-lg-2 mb-0 mb-lg-0 pr-2 pr-md-0">
                        <div className="d-flex align-middle">

                            {/* <p className='mt-1 mb-0 mr-1 font-size-lg-12 font-size-14 font-weight-medium font-weight-lg-light text-secondary'>
                                        {memberCount}
                                        </p> */}
                            <div className="w-100">
                                <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light salutation-dropdown'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={memberfieldData.salutation.extra.bottomSheetTitle}
                                    defaultLabel=''
                                    menuList={memberfieldData.salutation.extra.optionList}
                                    onSelect={(value) => updateValues(formController, member[0], "salutation", value)}
                                    value={memberfieldData.salutation.value}
                                    showErrorMsg={memberfieldData.salutation.error !== null}
                                    errorMsg={memberfieldData.salutation.error}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="mb-0 mb-lg-0 pr-2 pr-md-0">
                        <Form.Control
                            placeholder={memberfieldData.first_name.placeholder}
                            value={memberfieldData.first_name.value}
                            onChange={(event) => updateValues(formController, member[0], "first_name", event.target.value)}
                            disabled={memberfieldData.first_name.disabled}
                            className={`${memberfieldData.first_name.error !== null ? "validation-border font-weight-light font-size-12" : "font-size-12 font-weight-light "} calculator-monthly-income-field`}
                            style={{ border: "1px solid #797979" }}
                        />
                        {memberfieldData.first_name.error && (
                            <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>
                                {memberfieldData.first_name.error}
                            </p>
                        )}
                    </div>

                    <div className="mx-lg-2 mb-0 mb-lg-0 pr-2 pr-md-0">
                        <Form.Control
                            placeholder={memberfieldData.middle_name.placeholder}
                            value={memberfieldData.middle_name.value}
                            onChange={(event) => updateValues(formController, member[0], "middle_name", event.target.value)}
                            disabled={memberfieldData.middle_name.disabled}
                            className={`${memberfieldData.middle_name.error !== null ? "validation-border font-weight-light font-size-12" : "font-size-12 font-weight-light "} calculator-monthly-income-field`}
                            style={{ border: "1px solid #797979" }}
                        />
                        {memberfieldData.middle_name.error && (
                            <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>
                                {memberfieldData.middle_name.error}
                            </p>
                        )}
                    </div>

                    <div className="mr-lg-2 mb-0 mb-lg-0 pr-2 pr-md-0">
                        <Form.Control
                            placeholder={memberfieldData.last_name.placeholder}
                            value={memberfieldData.last_name.value}
                            onChange={(event) => updateValues(formController, member[0], "last_name", event.target.value)}
                            disabled={memberfieldData.last_name.disabled}
                            className={`${memberfieldData.last_name.error !== null ? "validation-border font-weight-light font-size-12" : "font-size-12 font-weight-light "} calculator-monthly-income-field`}
                            style={{ border: "1px solid #797979" }}
                        />
                        {memberfieldData.last_name.error && (
                            <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>
                                {memberfieldData.last_name.error}
                            </p>
                        )}
                    </div>


                    {/* gender in table and desktop view */}
                    <div className='other-details-section-gender flex-xs-column flex-lg-row  d-none d-lg-flex'>
                        <img src={GenderIcon} alt='calender-icon' className='add-family-member-card-top-img d-inline d-xl-none mr-1 mb-sm-1 mb-lg-0' />

                        <BottomsheetDropdown
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light gender-dropdown'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={memberfieldData.gender.extra.bottomSheetTitle}
                            defaultLabel='Select'
                            disabled={memberfieldData.gender.disabled}
                            menuList={memberfieldData.gender.extra.optionList}
                            onSelect={(value) => updateValues(formController, member[0], 'gender', value)}
                            value={memberfieldData.gender.value}
                            showErrorMsg={memberfieldData.gender.error !== null}
                            errorMsg={memberfieldData.gender.error}
                        />
                    </div>
                </div>
                {/* <hr className='w-100 border-secondary-opacity-50 my-2 d-xl-none d-none d-lg-inline' /> */}

                <div className='family-member-other-details-section justify-content-between '>
                    {/* gender in mobile veiw */}
                    <div className='other-details-section-gender mt-3 mt-xl-0 pr-xl-2 d-lg-none '>
                        <div className='d-flex d-xl-none align-items-center  mb-1'>
                            <img src={GenderIcon} alt='calender-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-light text-description-text-color ml-1 mb-0 ml-md-3'>
                                {memberfieldData.gender.label}
                            </p>
                        </div>

                        <BottomsheetDropdown
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light gender-dropdown'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={memberfieldData.gender.extra.bottomSheetTitle}
                            defaultLabel='Select'
                            disabled={memberfieldData.gender.disabled}
                            menuList={memberfieldData.gender.extra.optionList}
                            onSelect={(value) => updateValues(formController, member[0], 'gender', value)}
                            value={memberfieldData.gender.value}
                            showErrorMsg={memberfieldData.gender.error !== null}
                            errorMsg={memberfieldData.gender.error}
                        />
                    </div>

                    <div
                        className={
                            `${memberfieldData.gender.error !== null
                                ? "mt-3 mt-xl-0 other-details-section-dob pr-xl-2"
                                : "mt-3 mt-xl-0 other-details-section-dob pr-xl-2"
                            }`}
                    >
                        <div className='d-flex align-items-center d-xl-none mb-1 mb-lg-2'>
                            <img src={DOBIcon} alt='calender-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-light text-description-text-color ml-1 mb-0 ml-md-3'>
                                {memberfieldData.dob.label}
                            </p>
                        </div>
                        <DatepickerModal
                            minDate={memberfieldData.dob.extra.minDate}
                            maxDate={memberfieldData.dob.extra.maxDate}
                            value={memberfieldData.dob.value}
                            date={memberfieldData.dob.value}
                            onChange={(value) => updateValues(formController, member[0], 'dob', value)}
                            showErrorMsg={memberfieldData.dob.error !== null}
                            textStyle='font-size-lg-12 font-size-14 font-weight-light'
                            errorMsg={memberfieldData.dob.error}
                        // memberType={member[1].value.family_member_type}
                        />
                    </div>

                    {/* nationality in table & desktop view */}
                    <div className='mt-3 mt-xl-0 other-details-section-nationality pr-xl-2 d-none d-lg-block' >
                        <div className='d-flex d-xl-none align-items-center  mb-1'>
                            <img src={NationalityIcon} alt='income-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-normal text-description-text-color ml-1 mb-0 ml-md-3'>
                                {memberfieldData.nationality.label}
                            </p>
                        </div>

                        <BottomsheetDropdown
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={memberfieldData.nationality.extra.bottomSheetTitle}
                            defaultLabel={memberfieldData.nationality.label}
                            menuList={memberfieldData.nationality.extra.optionList}
                            value={memberfieldData.nationality.value}
                            onSelect={(value) => updateValues(formController, member[0], 'nationality', value)}
                            showErrorMsg={memberfieldData.nationality.error != null}
                            disabled={false}
                        />
                    </div>

                    <div className={`mt-3 mt-xl-0 other-details-section-monthlyincome pr-xl-2
                     ${showmonthlyIncome
                            ? "visible"
                            : "invisible"
                        }
                    `}>
                        <div className='d-flex d-xl-none align-items-center mb-1'>
                            <img src={MonthlyIncomeIcon} alt='income-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-normal text-description-text-color ml-1 mb-0 ml-md-3'>
                                {memberfieldData.monthly_income_value.label}
                            </p>
                        </div>
                        {
                            memberfieldData.monthly_income_value.type === 'text'
                                ? <>
                                    <Form.Control
                                        placeholder={memberfieldData.monthly_income_value.placeholder}
                                        value={memberfieldData.monthly_income_value.value}
                                        onChange={(event) => {

                                            if (NUMBER_REGEX.test(event.target.value)) {
                                                return updateValues(formController, member[0], 'monthly_income_value', event.target.value)
                                            }
                                            if (event.target.value.length <= 1) {
                                                return updateValues(formController, member[0], 'monthly_income_value', '')
                                            }
                                        }}
                                        disabled={memberfieldData.monthly_income_value.disabled}
                                        className={
                                            `${memberfieldData.monthly_income_value.error !== null
                                                ? "validation-border font-weight-light font-size-12"
                                                : "font-size-12 font-weight-light "
                                            } calculator-monthly-income-field`}
                                        style={{ border: "1px solid #797979" }}
                                    />
                                    {memberfieldData.monthly_income_value.error && (
                                        <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>
                                            {memberfieldData.monthly_income_value.error}
                                        </p>
                                    )}
                                </>
                                : <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={memberfieldData.monthly_income_dropdown_option.extra.bottomSheetTitle}
                                    defaultLabel="Select"
                                    menuList={memberfieldData.monthly_income_dropdown_option.extra.optionList}
                                    value={memberfieldData.monthly_income_dropdown_option.value}
                                    onSelect={(value) => updateValues(formController, member[0], 'monthly_income_dropdown_option', value)}
                                    showErrorMsg={memberfieldData.monthly_income_dropdown_option.error != null}
                                    errorMsg={memberfieldData.monthly_income_dropdown_option.error}
                                    disabled={memberfieldData.monthly_income_dropdown_option.disabled}
                                />
                        }
                        <div>

                        </div>
                    </div>
                    <div className='mt-3 mt-xl-0 other-details-section-current-life-cover'>
                        <div className='d-flex d-xl-none align-items-center mb-1'>
                            <img src={lifeCoverIcon} alt='income-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-light text-description-text-color ml-1 mb-0 ml-md-3'>
                                {memberfieldData.current_life_cover.label}
                            </p>
                        </div>
                        <BottomsheetDropdown
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={memberfieldData.current_life_cover.extra.bottomSheetTitle}
                            menuList={memberfieldData.current_life_cover.extra.optionList}
                            value={memberfieldData.current_life_cover.value}
                            onSelect={(value) => updateValues(formController, member[0], 'current_life_cover', value)}
                            showErrorMsg={memberfieldData.current_life_cover.error !== null}
                            disabled={memberfieldData.current_life_cover.disabled}
                            errorMsg={memberfieldData.current_life_cover.error}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

}
export default observer(AddLifeAssuredData);